import React from 'react';
import {
  Route,
  Redirect,
  RouteProps,
} from 'react-router-dom';
import AuthUtils from '../shared/utils/auth-utils';
import { buildLoginPath } from '../shared/utils/redirect-utils';

interface PrivateRouteProps extends RouteProps {
  children: JSX.Element,
  path: string | string[],
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { children, path, ...other } = props;

  return (
    <Route
      path={path}
      render={({ location }) => (AuthUtils.isAuth() ? (
        <>
          {children}
        </>
      ) : (
        <Redirect
          to={buildLoginPath(location)}
        />
      ))}
      {...other}
    />
  );
}

export default PrivateRoute;